import React from 'react'
import Component, { type PromptBoxRef, type PromptBoxProps } from './PromptBox'
import Wrapper from './PromptBox.wrapper'

import { ACCEPT_FILE_TEXT_TYPES } from './consts'

export * from './PromptBox'
export * from './consts'

function PromptBox(props: PromptBoxProps, ref: React.ForwardedRef<PromptBoxRef>) {
  const allowedFileTypes = props.allowUpload ? props.allowedFileTypes : ACCEPT_FILE_TEXT_TYPES

  return (
    <Wrapper allowedFileTypes={allowedFileTypes ?? ACCEPT_FILE_TEXT_TYPES}>
      <Component {...props} ref={ref} />
    </Wrapper>
  )
}

export default React.forwardRef<PromptBoxRef, PromptBoxProps>(PromptBox)
